const removeKeyFromObj = (key, obj) => {
  const newObj = { ...obj };
  delete newObj[key];
  return newObj;
};

const sortByKey = (array, key) => {
  return array.sort(function (a, b) {
    var x = a[key];
    var y = b[key];
    return x < y ? -1 : x > y ? 1 : 0;
  });
};

const utils = { removeKeyFromObj, sortByKey };

export default utils;
